<template>
  <v-navigation-drawer
    v-model="drawer"
    width="450"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }} : {{ nombre }} {{ apellidos }}</span>
    </div>

    <div class="pl-6 pt-3 pr-6 w-crud-form">
      <template>
        <v-row justify="center">
          <v-row>
            <v-col cols="12">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_cese"
                    label="Fecha de Cese"
                    readonly
                    clearable
                    v-on="on"
                    hide-details
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_cese"
                  @input="menu1 = false"
                  no-title
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span style="color:red">{{ mensaje }}</span>
          </v-col>
        </v-row>
      </template>
    </div>

    <div class="mt-2 pl-3 pt-2 pr-3">
      <template>
        <v-row>
          <v-col cols="6" class="pt-1 pb-1">
            <v-btn block height="40" dark color="red" @click="cierraModal()">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6" class="pt-1 pb-1">
            <v-btn dark color="success" block height="40" @click="actualiza()">
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Baja",
  data() {
    return {
      nombre: null,
      apellidos: null,
      titleForm: null,
      menu1: false,
      fecha_cese: null,
      fecha_ingreso: null,
      drawer: false,
      verifica: false,
      auxEmployee: null,
      mensaje: "",
    };
  },
  computed: {},
  methods: {
    ...mapActions("employees", [
      "getEmployees",
      "store",
      "update",
      "bajaEmpleado",
    ]),
    async showForm(title, employee) {
      this.titleForm = title;
      this.nombre = employee.first_name;
      this.apellidos = employee.last_name;
      this.auxEmployee = employee;
      this.fecha_ingreso = employee.fecha_ingreso;
      this.drawer = !this.drawer;
    },
    verificaFunction() {
      if (this.fecha_cese != null) {
        if (this.fecha_cese > this.fecha_ingreso) {
          this.auxEmployee.fecha_cese = this.fecha_cese;
        } else {
          this.mensaje =
            "La fecha de Cese debe ser mayor a la fecha de ingreso.";
        }
      } else {
        this.mensaje = "Debe seleccionar una fecha de Cese.";
      }
    },
    async actualiza() {
      this.verificaFunction();
      // console.log(this.auxEmployee)
      await this.bajaEmpleado(this.auxEmployee);
      this.cierraModal();
    },
    limpiaModal() {
      this.title = null;
      this.fecha_cese = null;
      this.mensaje = null;
    },
    cierraModal() {
      this.limpiaModal();
      this.drawer = false;
    },
  },
  create() {},
};
</script>

<style scoped></style>
